// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-38ed449c] .el-divider,\n.el-divider--horizontal[data-v-38ed449c] {\n  margin: 5px 0;\n}\n.item[data-v-38ed449c] {\n  margin: 0 5px;\n}", ""]);
// Exports
module.exports = exports;
